(() => {
  const KEY = 'raymae_saved_products';

  const readSaved = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  };

  const writeSaved = (items) => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  };

  const updateButton = (button) => {
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const saved = readSaved();
    const active = saved.includes(handle);
    button.classList.toggle('is-saved', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    const label = button.querySelector('[data-rm-wishlist-label]');
    if (label) label.textContent = active ? 'Saved' : 'Save for later';
  };

  const bind = (button) => {
    updateButton(button);
    button.addEventListener('click', () => {
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const saved = readSaved();
      const index = saved.indexOf(handle);
      if (index >= 0) saved.splice(index, 1);
      else saved.push(handle);
      writeSaved(saved);
      updateButton(button);
    });
  };

  const init = () => document.querySelectorAll('[data-rm-wishlist]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
